import { render, staticRenderFns } from "./MailSettingsPage.vue?vue&type=template&id=39475329&scoped=true&"
import script from "./MailSettingsPage.vue?vue&type=script&lang=js&"
export * from "./MailSettingsPage.vue?vue&type=script&lang=js&"
import style0 from "./MailSettingsPage.vue?vue&type=style&index=0&id=39475329&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39475329",
  null
  
)

export default component.exports